import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  memo,
} from "react";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import OverviewNudgeComp from "./overviewNudgeComp";
import SideCardTabComponent from "../../genericComponents/sideCardTabComponent";
// import ValueSellingPrompters from "./vaueSelleingPrompters";
import { fetchOpportunityContacts } from "../../../../services/accIqService";
import ComingSoon from "./comingSoonComp";
import ContactNudgeComponentCard from "./contactsForNudge/contactNudgeComponentCard";
import NudgeCard from "./nudgeCard";
import GenericFilterComponent from "../../genericComponents/GenericFilterComponent";
import { useParams } from "react-router-dom";

const NudgesWithPromptTilesV2Filters = ({
  activeUnitNudges,
  selectedItems,
  setSelectedItems,
  activeUnit,
  tabs,
  setActiveUnit,
}) => {
  const { clientName } = useParams();
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [nudgeModalData, setNudgeModalData] = useState(null);
  const [contactsData, setContactsData] = useState([]);
  const [selectedNudgeTypes, setSelectedNudgeTypes] = useState([]);

  // Memoized high impact icon to prevent unnecessary re-renders
  const highImpactIcon = useMemo(
    () => (
      <img
        src="/img/icons/trending-up_backcolor.png"
        alt="High Impact"
        className="img-fluid ms-2 pulse-animation"
        style={{ width: "28px", height: "28px" }}
      />
    ),
    []
  );

  // Memoized tab configuration to prevent recreation on every render
  const tabConfig = useMemo(() => {
    const baseConfig = {
      opp_bc: {
        title: "Opportunity Battlecard​",
        content: <OverviewNudgeComp nudgeData={nudgeModalData} businessUnit={activeUnit} />,
      },

    };
  
    // Create a config object we'll build upon
    let config = {...baseConfig};
  
    // Add contacts tab if contactsData exists and has items
    if (contactsData?.length > 0) {
      config = {
        ...config,
        contacts: {
          title: "Contacts",
          content: <ContactNudgeComponentCard contactsData={contactsData} />,
        },
      };
    }
  
    // Add additional tabs only for MARKETS & MARKETS client
    if (clientName === "MARKETS & MARKETS") {
      const marketsConfig = {
        pitch_stories: {
          title: "Pitch/stories​",
          content: <ComingSoon />,
        },
        business_slide: {
          title: "Business slide​",
          content: <ComingSoon />,
        },
        value_selling: {
          title: "Value Selling​",
          content: <ComingSoon />,
        },
        next_steps: {
          title: "Next Steps​",
          content: <ComingSoon />,
        },
      };
  
      config = {
        ...config,
        ...marketsConfig,
      };
    }
  
    return config;
  }, [nudgeModalData, contactsData, activeUnit, clientName]);
  // Memoized sorted nudges to avoid recalculating on every render
  const sortedNudges = useMemo(() => 
    activeUnitNudges
      .map((buNudge) => ({
        ...buNudge,
        nudgeCount: buNudge?.nudges?.length || 0,
      }))
      .sort((a, b) => b.nudgeCount - a.nudgeCount),
    [activeUnitNudges]
  );

  // Memoized filtered data based on selected nudge types
  const filteredData = useMemo(() => 
    selectedNudgeTypes.length > 0
      ? sortedNudges.filter(e => selectedNudgeTypes.includes(e._id))
      : sortedNudges,
  [sortedNudges, selectedNudgeTypes]);

  // Flatten and sort the nudges for rendering
  const dataToRender = useMemo(() => 
    filteredData
      .flatMap((data) => data.nudges || [])
      .sort((a, b) => new Date(b?.nudge?.event_date) - new Date(a?.nudge?.event_date)),
  [filteredData]
  );

  // Memoized filter configuration
  const filterConfig = useMemo(() => [
    {
      title: "Nudge Type",
      data: sortedNudges.map((category) => ({
        label: category._id,
        count: category?.nudges?.length || 0,
        checked: selectedNudgeTypes.includes(category._id),
      })),
      onClickFilter: (item) => {
        setSelectedNudgeTypes(prev => 
          prev.includes(item.label) 
            ? prev.filter(type => type !== item.label) 
            : [...prev, item.label]
        );
      },
    },
  ], [sortedNudges, selectedNudgeTypes]);

  // Memoized modal title content
  const modalTitleContent = useMemo(() => (
    <div style={{
      marginLeft: "1vh",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column",
    }}>
      <div style={{
        color: "#15171A",
        paddingTop: "1vh",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        whiteSpace: "normal",
        overflow: "visible",
        wordBreak: "break-word",
        minHeight: "fit-content",
        fontSize: "1.14rem",
        fontWeight: "bold",
      }}>
        {nudgeModalData?.event}
        {nudgeModalData?.impact_score >= 8 && highImpactIcon}
      </div>
      {nudgeModalData?.event_date && (
        <div style={{ paddingLeft: "2vh " }}>
          {new Date(nudgeModalData.event_date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </div>
      )}
    </div>
  ), [nudgeModalData, highImpactIcon]);

  // Memoized event handlers
  const handleCheckboxChange = useCallback((nudgeId) => {
    setSelectedItems((prev) =>
      prev.includes(nudgeId)
        ? prev.filter((id) => id !== nudgeId)
        : [...prev, nudgeId]
    );
  }, [setSelectedItems]);

  const handleMore = useCallback(async (data) => {
    setShowMoreModal(true);
    setNudgeModalData(data.nudge);
    const contacts = await fetchOpportunityContacts(data?.opportunity_id);
    setContactsData(contacts);
    document.getElementById("nudges")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  if (!dataToRender?.length >0 ) {
    return null;
  }
  return (
    <>
    <div className="container-fluid">
      <div className="row">
        <GenericFilterComponent filterConfig={filterConfig} />
        <div 
          className="col-md-9 scrollable_nudge_block"  
          
        >
          {dataToRender?.length>0 ? <div className="row">
            {dataToRender.map((nudgeData,index) => (
              <NudgeCard
                key={nudgeData?.opportunity_id||index}
                handleCheckboxChange={handleCheckboxChange}
                handleMore={handleMore}
                nudgeData={nudgeData}
                selectedItems={selectedItems}
              />
            ))}
          </div> : <div className="row" style={{ minWidth:"35vw"}}>No Data Avaliable</div>}
        </div>
      </div>
      </div>
      
      <GenericOverviewSideCard
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={null}
        comp={
          <SideCardTabComponent
            tabConfig={tabConfig}
            titleForSideCard={modalTitleContent}
          />
        }
      />
    </>
  );
};

export default memo(NudgesWithPromptTilesV2Filters);